import { AxiosHeaders, AxiosInstance } from 'axios';
import { BaseURL } from '../../constants/global';
import NetworkInstanceProvider from './network';
import {
  APIRequestMethods,
  APIServiceRequestMethodInterface,
  APIServiceRequestMethodPropsInterface,
  APIServiceRequestInterface,
  APIServiceRequestPropsInterface,
} from './types';

class APIService {
  private static instance: AxiosInstance;
  private static protectedInstance: AxiosInstance;

  constructor(baseURL: string = BaseURL ?? '') {
    APIService.instance = NetworkInstanceProvider.initiateNetworkInstance({
      baseURL,
      isProtected: false,
    });
    APIService.protectedInstance =
      NetworkInstanceProvider.initiateNetworkInstance({
        baseURL,
        isProtected: true,
      });
  }

  private apiRequest: APIServiceRequestInterface = <ResponseInterface>({
    method,
    path: url,
    data,
    params,
    paramsSerializer,
    headers: requestHeaders,
    responseType,
    isProtected = true,
  }: APIServiceRequestPropsInterface) => {
    if (isProtected) {
      return APIService.protectedInstance.request<ResponseInterface>({
        method,
        url,
        data,
        params,
        paramsSerializer,
        headers: requestHeaders as AxiosHeaders,
        responseType,
      });
    }
    return APIService.instance.request<ResponseInterface>({
      method,
      url,
      data,
      params,
      headers: requestHeaders as AxiosHeaders,
      responseType,
    });
  };

  public get: APIServiceRequestMethodInterface = <ResponseInterface>(
    props: APIServiceRequestMethodPropsInterface
  ) => {
    return this.apiRequest<ResponseInterface>({
      method: APIRequestMethods.GET,
      ...props,
    });
  };

  public post: APIServiceRequestMethodInterface = <ResponseInterface>(
    props: APIServiceRequestMethodPropsInterface
  ) =>
    this.apiRequest<ResponseInterface>({
      method: APIRequestMethods.POST,
      ...props,
    });

  public patch: APIServiceRequestMethodInterface = <ResponseInterface>(
    props: APIServiceRequestMethodPropsInterface
  ) =>
    this.apiRequest<ResponseInterface>({
      method: APIRequestMethods.PATCH,
      ...props,
    });

  public put: APIServiceRequestMethodInterface = <ResponseInterface>(
    props: APIServiceRequestMethodPropsInterface
  ) =>
    this.apiRequest<ResponseInterface>({
      method: APIRequestMethods.PUT,
      ...props,
    });

  public delete: APIServiceRequestMethodInterface = <ResponseInterface>(
    props: APIServiceRequestMethodPropsInterface
  ) =>
    this.apiRequest<ResponseInterface>({
      method: APIRequestMethods.DELETE,
      ...props,
    });
}

export default APIService;
